// extracted by mini-css-extract-plugin
export default {"howItWorks":"full-product-module--howItWorks--kjLHq","howItWorksMobile":"full-product-module--howItWorksMobile--d27KU"};